import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Map Institute Assessors")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institutes", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "row mt-5 pt-3" }
const _hoisted_18 = { class: "col-md-5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Unmapped Assessors", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "row mt-2" }
const _hoisted_24 = { class: "col-md-6 text-end" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right fs-3" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-left fs-3" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6 text-end" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-double-right fs-3" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-double-left fs-3" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "col-md-5" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Mapped Assessors", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_42 = { class: "col-md-12 d-flex justify-content-center" }
const _hoisted_43 = ["data-kt-indicator"]
const _hoisted_44 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_45 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_46 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      name: "tranche_id",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (tranche) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tranche.id,
                            label: tranche.label,
                            value: tranche.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tranche.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Partner",
                      modelValue: _ctx.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                      filterable: "",
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.assessorListFirst())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_short_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("[" + _toDisplayString(info.entity_short_name) + "]-" + _toDisplayString(info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Institute",
                      modelValue: _ctx.institute_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.institute_id) = $event)),
                      filterable: "",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.assessorList())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: inst.id,
                            label: inst.institute_name,
                            value: inst.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(inst.institute_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      multiple: "",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.assesor_ids) = $event)),
                      size: "12",
                      style: {"height":"250px !important","overflow":"auto"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assessorInfos, (assesor, key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: key,
                          value: { id: assesor?.id, name: assesor?.name }
                        }, _toDisplayString(assesor?.name), 9, _hoisted_21))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.assesor_ids]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedAssessors())),
                          class: "btn btn-success mt-5 px-7"
                        }, _hoisted_26)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.unselectedAssessors())),
                          class: "btn btn-success mt-5 px-7"
                        }, _hoisted_29)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectAllAssesor())),
                          class: "btn btn-danger mt-5"
                        }, _hoisted_33)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.unselectAllAssesor())),
                          class: "btn btn-danger mt-5"
                        }, _hoisted_36)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _hoisted_39,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      multiple: "",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.select_assesor_ids) = $event)),
                      size: "12",
                      style: {"height":"250px !important","overflow":"auto"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assessorSelected, (assessor, key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: key,
                          value: { id: assessor?.id, name: assessor?.name }
                        }, _toDisplayString(assessor?.name), 9, _hoisted_40))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.select_assesor_ids]
                    ])
                  ]),
                  (_ctx.showSubmit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("button", {
                            "data-kt-indicator": _ctx.loading ? 'on' : null,
                            class: "btn btn-lg btn-success",
                            type: "button",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formSubmit()))
                          }, [
                            (!_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                  _createTextVNode(" Submit "),
                                  _createElementVNode("span", _hoisted_45, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                  _createTextVNode(" Please wait... "),
                                  _hoisted_47
                                ]))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_43)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, _ctx.loader]
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}